import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BuscaBitacoraService } from '../../servicios/busca-bitacora.service';
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { BuscaBitacora, CatConceptoCostos, CatUsuarios, FGetPrivileges, FGetPrivilegesInput, BuscaBitacoraInput, CatConceptos, Aguas, AguaBuscaCuentas, Privilegios, AguaBuscaCuentasInput } from '../../entidades/entidades';
import { PrivilegiosService } from "app/servicios/privilegios.service";
import { CatUsuariosService } from "app/servicios/cat-usuarios.service";
import { CatUnidadCobrosService } from "app/servicios/cat-unidad-cobros.service";
import { CatConceptoCostosService } from "app/servicios/cat-concepto-costos.service";
import { CatConceptosService } from '../../servicios/cat-conceptos.service';
import { AguasService } from '../../servicios/aguas.service';

import { first } from 'rxjs/operators';
import { AguaBuscaCuentasService } from 'app/servicios/agua-busca-cuentas.service';
declare var $: any;

@Component({
  selector: "app-busca-bitacora-grid",
  templateUrl: "./busca-bitacora-grid.component.html",
  styleUrls: ["./busca-bitacora-grid.component.css"],
})
export class BuscaBitacoraGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  buscaBitacora: any;
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedBuscaBitacora: { [s: string]: BuscaBitacora } = {};
  clonedPrivilegios: SelectItem[];
  clonedCatUsuarios: SelectItem[];
  CatConceptos: SelectItem[];
  idModuloSeleccionado;
  idRolSeleccionado;
  privilegios: Privilegios[] = [];
  privilegiosGlobal: Privilegios[] = [];
  catUsuarios: CatUsuarios[];
  catConceptoCostos: CatConceptoCostos[];
  buscando: boolean = false;
  _buscaBitacoraInput:BuscaBitacoraInput;
  aguasProceso: Aguas;
  datosAguaCuenta = new AguaBuscaCuentas();
  datosAguas = new Aguas();
  showAccountFields: boolean = true;
  progressBar: boolean = false;
 

  @Input("esEdoCuenta") esEdoCuenta: boolean = false;

  @Input('buscaBitacoraInput') buscaBitacoraInput: BuscaBitacoraInput;
  @Input("aguaBuscaCuentas") aguaBuscaCuentas: EventEmitter<AguaBuscaCuentas>;
  @Output("aguasOutput") aguasOutput: EventEmitter<Aguas>;

  first = 0;
  cuenta: string;

  constructor(
    //  private buscaBitacoraService: BuscaBitacoraService,
    private privilegiosService: PrivilegiosService,
    private catUsuariosService: CatUsuariosService,
    private CatConceptosService: CatConceptosService,
    private BuscaBitacoraService: BuscaBitacoraService,
    private aguasService: AguasService,
    private aguaBuscaCuentasService: AguaBuscaCuentasService
  ) {
    this.aguasOutput = new EventEmitter();
    this.aguaBuscaCuentas = new EventEmitter();
   }



  onKeydown(event) {
    if (event.key === "Enter") {
      this.buscar();
    }
  }

  async ngOnInit() {
    
    this._buscaBitacoraInput= new BuscaBitacoraInput();
    this._buscaBitacoraInput.fechaIn= new Date();
    this._buscaBitacoraInput.fechaFin=  new Date();

    let date = new Date()

    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    let dateDefault;
    if (month < 10)
      dateDefault=`${year}-0${month}-${day}`;
    else
      dateDefault=`${year}-${month}-${day}`;

    if (day < 10)
      dateDefault=`${year}-${month}-0${day}`;
    else
      dateDefault=`${year}-${month}-${day}`;



    this._buscaBitacoraInput.fechaIn= dateDefault;
    this._buscaBitacoraInput.fechaFin= dateDefault;

    await this.getAllCatUsuarios();
    //await this.getAllPrivilegios();
    await this.getAllCatConceptos();
    // this.getAllBuscaBitacora();

    
    if(this.buscaBitacoraInput)
    {
      this._buscaBitacoraInput.cuentaAgua = this.buscaBitacoraInput.cuentaAgua;
      this._buscaBitacoraInput.fechaIn = null;
      this._buscaBitacoraInput.fechaFin = null;
      //cuenta_agua es igual a id_agua hasta este punto
      await this.getAguas(this.buscaBitacoraInput.cuentaAgua);
    }


    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
     /*  { field: "idAgua", header: "Agua", ordenar: true, styleHeader: "width: 150px;", }, */
      { field: "cuentaAgua", header: "Contrato", ordenar: true, styleHeader: "width: 80px;", },
      { field: "derivada", header: "Derivada", ordenar: true, styleHeader: "width: 80px;", },
      { field: "usario", header: "Usuario", ordenar: true, styleHeader: "width: 80px;", },
      { field: "privilegio", header: "Ventana", ordenar: true, styleHeader: "width: 100px;", },
      { field: "fecha", header: "Fecha", ordenar: true, styleHeader: "width: 100px;", },
      { field: "accion", header: "Acción", ordenar: true, styleHeader: "width: 120px;", },
      { field: "concepto", header: "Concepto", ordenar: true, styleHeader: "width: 150px;", },
      { field: "ip", header: "Ip", ordenar: true, styleHeader: "width: 150px;", },
      { field: "movimiento", header: "Movimiento", ordenar: true, styleHeader: "width: 150px;", }
    ];

    if (!this.esEdoCuenta) {
      this.showAccountFields = false;
    }
 
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  // add() {
  //   let buscaBitacoraNew = new BuscaBitacora();
  //   buscaBitacoraNew.cambio = true;
  //   this.buscaBitacora.unshift(buscaBitacoraNew);
  // }

  async getAguas(id){
    try
    {
      this.progressBar = true;
    const datoRetorno = await this.aguasService.getSingle(id).toPromise();
    this._buscaBitacoraInput.cuentaAgua = datoRetorno.cuentaAgua;

    let resultado = await this.BuscaBitacoraService.getBusquedas(this._buscaBitacoraInput).toPromise()
    this.buscaBitacora=resultado;      
  } catch (e) {
    this.muestraMensaje.error(e , "top", "center");
  } finally {
     console.log("Paso por getAguas")
     this.progressBar = false;
  }

  }

  async limpiar() {
    this._buscaBitacoraInput.cuentaAgua = null;
    this._buscaBitacoraInput.cuentaAguaFin = null;
    this._buscaBitacoraInput.fechaFin = null;
    this._buscaBitacoraInput.fechaIn = null;
    this._buscaBitacoraInput.idUsuario = null;
    this._buscaBitacoraInput.numSolicitud = null;
    this._buscaBitacoraInput.privilegio = null;
    this._buscaBitacoraInput.concepto = null; 
    this.buscaBitacora= null;
    this.cuenta = null;
  }

  async childAguaBuscaCuentasGrid(aguas: Aguas) {
    try{
      $("#exampleModalLong").modal('hide');
      if (!aguas) {
        this.aguasOutput.emit(null);
        return;
      }
      this.aguasOutput.emit(null);
      this.aguasOutput.emit(aguas);
      this._buscaBitacoraInput.idAgua = aguas.id;
      this._buscaBitacoraInput.cuentaAgua = null;
      this._buscaBitacoraInput.cuentaAguaFin = null;
      let resultado = await this.BuscaBitacoraService.getBusquedas(this._buscaBitacoraInput).toPromise()
      if(Object.keys(resultado).length > 0){
        this.buscaBitacora=resultado;
      }else{
        this.buscaBitacora=null;
        this.muestraMensaje.error( "No se encontró registro", "top", "center");
      }
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    } finally {
      // console.log("Paso por EstadoCuentaMasivo")
    }
    
  }

  async buscaCuenta(){
    try{
        this.aguasOutput.emit(null);
        this.aguaBuscaCuentas.emit(null);
    
        let buscaAgua = new AguaBuscaCuentasInput;
        buscaAgua.cuentaAgua = parseInt(this.cuenta);
    
        this.datosAguaCuenta.cuentaAgua = buscaAgua.cuentaAgua;
        if(this.datosAguaCuenta.cuentaAgua == null){
          this.muestraMensaje.error('Ingresa una cuenta para la busqueda', 'top', 'center'); return
        }
        const datoretorno = await this.aguaBuscaCuentasService
        .add(buscaAgua).toPromise();
        if(Object.keys(datoretorno).length == 1){
          this._buscaBitacoraInput.cuentaAgua = null;
          this._buscaBitacoraInput.cuentaAguaFin = null;
          this._buscaBitacoraInput.idAgua =  datoretorno[0].id; 
          let resultado = await this.BuscaBitacoraService.getBusquedas(this._buscaBitacoraInput).toPromise()
          if(Object.keys(resultado).length > 0){
            this.buscaBitacora=resultado;
          }else{
            this.buscaBitacora=null;
            this.muestraMensaje.error( "No se encontró registro", "top", "center");
          }
    
    
        } else if (Object.keys(datoretorno).length >= 2){
          this.aguaBuscaCuentas.emit(null);
          this.aguaBuscaCuentas.emit(datoretorno);
          $("#exampleModalLong").modal();
        } else{
          this.muestraMensaje.error( "No se encontró cuenta", "top", "center");
        }
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    } finally {
      // console.log("Paso por EstadoCuentaMasivo")
    }

    
  }

  async buscar() 
  {
    if (this._buscaBitacoraInput.cuentaAgua == null &&
      this._buscaBitacoraInput.cuentaAguaFin == null &&
      this._buscaBitacoraInput.idAgua == null &&
      this._buscaBitacoraInput.privilegio == null &&
      this._buscaBitacoraInput.idUsuario == null &&
      this._buscaBitacoraInput.concepto == null) {
        this._buscaBitacoraInput.cuentaAgua = null;
        this._buscaBitacoraInput.cuentaAguaFin = null;
        this._buscaBitacoraInput.idAgua = null;
        this._buscaBitacoraInput.privilegio = null;
        this._buscaBitacoraInput.idUsuario = null;
        this._buscaBitacoraInput.concepto = null;
        this._buscaBitacoraInput.fechaIn = null;
        this._buscaBitacoraInput.fechaFin = null;
      }
    if(this.cuenta != null && this.cuenta != ""){
      this.buscaCuenta();
    }else{
      this.cuenta = null;
      this._buscaBitacoraInput.idAgua = null;
      this.first = 0;
      if (this._buscaBitacoraInput.fechaFin < this._buscaBitacoraInput.fechaIn) {
        this.buscaBitacora=null;
        this.muestraMensaje.error('La fecha posterior debe ser más actual', 'top', 'center'); return
      } else if (this._buscaBitacoraInput.cuentaAguaFin < this._buscaBitacoraInput.cuentaAgua) {
        this.buscaBitacora=null;
        this.muestraMensaje.error('Cuenta Inicio debe ser menor de Cuenta Fin', 'top', 'center'); return
      }
    
      let resultado = await this.BuscaBitacoraService.getBusquedas(this._buscaBitacoraInput).toPromise()
      this.buscaBitacora=resultado;
    }
  }
  //===============================================================
  //Funciones de la tabla
  //===============================================================


  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridBuscaBitacora() {
    try {
      for (let buscaBitacoraFor of this.buscaBitacora) {
        if (buscaBitacoraFor.baja) {
        } else if (buscaBitacoraFor.cambio) {
          buscaBitacoraFor.cambio = false;
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarBuscaBitacora");
    }
  }

  // prettier-ignore
  async getAllPrivilegios() {
    try {
      this.idModuloSeleccionado = null;
      this.idRolSeleccionado = null;
      let entGetPrivilegios = new FGetPrivilegesInput();
      entGetPrivilegios.pIdModulo = null;
      entGetPrivilegios.pIdPrivilegio = null;
      entGetPrivilegios.pIdRol = null;
      this.privilegios = await this.privilegiosService.getAll().toPromise();
      this.privilegiosGlobal = this.privilegios;
      this.clonedPrivilegios = this.privilegios.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });

      this.clonedPrivilegios.unshift({ label: "TODOS", value: null });
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllPrivilegios");
    }
  }

  // prettier-ignore
  async getAllCatUsuarios() {
    try {
      
      this.progressBar = true;
      const datoRetorno = await this.catUsuariosService.getAll().toPromise();
      this.clonedCatUsuarios = datoRetorno.map((datos) => {
        return { label: datos.nombreUsuario, value: datos.id };
      });
      this.clonedCatUsuarios.unshift({ label: "TODOS", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatUsuarios");
      
      this.progressBar = false;
    }
  }
  // prettier-ignore
  async getAllCatConceptos() {
   let catConceptos= await     this.CatConceptosService.getAll().toPromise();
    this.CatConceptos = catConceptos.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    this.CatConceptos.unshift({ label: "TODOS", value: null });
  }
}